
import vehicleSelectionTargetMixin from '@/mixins/vehicleSelectionTargetMixin'

export default {
  name: 'VehicleSelectionModal',

  mixins: [vehicleSelectionTargetMixin],

  props: {
    modalId: {
      type: String,
      default: 'modal-vehicle-selection',
    },
    vehicles: {
      type: Array,
      default: () => [],
    },
    plate: {
      type: String,
      default: null,
    },
  },

  methods: {
    show() {
      this.$bvModal.show(this.modalId)
    },

    hide() {
      this.$bvModal.hide(this.modalId)
    },

    loadProducts(vehicle) {
      const enrichedVehicle = {
        ...vehicle,
        search: this.plate || null,
      }

      this.$store.dispatch('setSelectedVehicle', enrichedVehicle)
      this.$store.dispatch('addToVehicleSearchHistory', enrichedVehicle)

      const consumed = this.consumeVehicleSelectionTarget(enrichedVehicle)

      this.hide()

      if (consumed) return

      this.$router.push(
        this.localePath({
          name: 'recherche-led-accessoires-brand-type-typeid',
          params: {
            brand: vehicle.brand.name.toLowerCase(),
            type: vehicle.name.toLowerCase(),
            typeid: vehicle.id,
          },
        })
      )
    },
  },
}
